import script from "./CreateUpdateFAQs.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateFAQs.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateFAQs.vue?vue&type=style&index=0&id=630d3165&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-630d3165"]])

export default __exports__